import React, { useContext, useState } from 'react';
import {  Button, Label,Table, Confirm, Container } from 'semantic-ui-react';
import { observer } from 'mobx-react-lite';
import BdodJobStore from '../../../app/stores/bdodjobsStore';
import { Link } from 'react-router-dom';


const BdodJobList: React.FC = () => {
  const [open, setOpen] = useState(false);
  const [bdodjobId, setBdodJobId] = useState("");
  const bdodjobStore = useContext(BdodJobStore);
  const {bdodjobsByDate: bdodjobsByDate,  
    deleteBdodJob: deleteBdodJob, submitting, target} = bdodjobStore;

  var totalAmount = 0;
  return (

      <Table celled>
    <Table.Header>
      <Table.Row>
      <Table.HeaderCell>Work Number</Table.HeaderCell>
          <Table.HeaderCell>Location</Table.HeaderCell>
          <Table.HeaderCell>Date</Table.HeaderCell>
            <Table.HeaderCell>Tech</Table.HeaderCell>
            <Table.HeaderCell>Status</Table.HeaderCell>
            <Table.HeaderCell>Payment</Table.HeaderCell>
            <Table.HeaderCell>Amount($)</Table.HeaderCell>
            <Table.HeaderCell>Remark</Table.HeaderCell>
        <Table.HeaderCell width={1}>Action</Table.HeaderCell>
      </Table.Row>
    </Table.Header>

    <Table.Body>
    {bdodjobsByDate.map(bdodjob => {
    totalAmount = totalAmount + bdodjob.amount;
    return (
    <Table.Row key={bdodjob.id}> 
    <Table.Cell>{bdodjob.workNumber}</Table.Cell> 
        <Table.Cell>{bdodjob.location}</Table.Cell> 
        <Table.Cell>
          <Label>{bdodjob.date && bdodjob.date.substr(8,2) + '/' +
    bdodjob.date.substr(5,2) + '/' + bdodjob.date.substr(0,4)}</Label>
        </Table.Cell>
        <Table.Cell>{bdodjob.tech}</Table.Cell> 
     <Table.Cell>{bdodjob.status}</Table.Cell> 
     <Table.Cell>{bdodjob.payment}</Table.Cell> 
     <Table.Cell>{bdodjob.amount}</Table.Cell> 
     <Table.Cell>{bdodjob.remark}</Table.Cell> 
        <Table.Cell>
        <Button.Group size='mini'>              
                <Button
                  as={Link}
                  to={`/financemanagement/bdodjob-edit/${bdodjob.id}`}
                  size='mini'
                  icon="edit"
                  color="blue"
                  title="Edit"
                />
                
                <Button
                  name={bdodjob.id}
                  size='mini'
                  loading={target === bdodjob.id && submitting}
                  onClick={() => {
                    setOpen(true);
                    setBdodJobId(bdodjob.id);
                  }}
                  icon="delete"
                  color="red"
                  title="Delete"
                />
                <Confirm
                    open={open}
                    onCancel={() => setOpen(false)}
                    onConfirm={(e) => {
                      deleteBdodJob(bdodjobId);
                        setOpen(false);
                    }}
                    content="Are you sure you want to delete ?"
                    confirmButton="Yes"
                    size="mini"
                    style={{
                      position: "relative",
                      maxHeight: "150px",
                      height: "auto",
                    }}
                  />
          </Button.Group>
        </Table.Cell>
      
      </Table.Row> 
    )})}
    </Table.Body>
    <Table.Footer>
        <Table.Row>
          <Table.HeaderCell>Total</Table.HeaderCell>
          <Table.HeaderCell />
          <Table.HeaderCell />
          <Table.HeaderCell />         
          <Table.HeaderCell />
          <Table.HeaderCell />
          <Table.HeaderCell>$ {totalAmount.toFixed(2)}</Table.HeaderCell>
          <Table.HeaderCell />
          <Table.HeaderCell />
        </Table.Row>
      </Table.Footer>
    
  </Table>

  );
};

export default observer(BdodJobList);
